import React, { useEffect } from "react"
import { icons } from "../../icons/image-container"
import { createUseStyles, useTheme } from "react-jss"
import CustomizedProgressBar from "../../components/Progress"
import { PIPELINE_NAMES_MAPPER } from "../../util/StaticData"
import Correct from "../../icons/correct.svg"
import Close from "../../icons/Close.svg"
import Parameters from "../../icons/parameters.svg"
import CustomIcon from "../../components/CustomIcon"
import { IPipelineData, Screen } from "../../util/interface"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import {
  deepActiveScreenSelecter,
  deepDiveDataSelector,
  deepDiveScreenChange,
} from "./MonitorSlice"
import { Box } from "@mui/material"

const useStyles = createUseStyles({
  key: {
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%",
  },
  value: {
    color: "#333",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "150%",
    display: "flex",
    alignItems: "center",
  },
  link: {
    color: "#00B1E9",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%", // You can also use '1.5' for a more precise value
    textDecorationLine: "underline",
    justifySelf: "flex-end",
    marginRight: 10,
    cursor: "pointer",
  },
  moreDetailsWrapper: {
    display: "grid",
    gridTemplateColumns: "1.5fr 1fr",
    width: "100%",
  },
  header: {
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "150%",
  },
  headerWrapper: {
    display: "grid",
    gridTemplateColumns: "20px 2fr 1fr",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
  },
  cross: {
    justifySelf: "flex-end",
    cursor: "pointer",
  },
})
const MonitoringDeepDiveTable = () => {
  const theme: any = useTheme()
  const classes = useStyles({ theme })
  const handleScreenChange = (
    type: Screen.Default | Screen.MoreDetails | Screen.ViewMore,
  ) => {
    dispatch(deepDiveScreenChange(type))
  }
  const dispatch = useAppDispatch()
  const activeScreen: any = useAppSelector(deepActiveScreenSelecter)
  const deepDiveData = useAppSelector(deepDiveDataSelector)

  useEffect(() => {
    // dispatch(deepDiveAsync())
  }, [])
  return (
    <div>
      <div className={classes.headerWrapper}>
        {activeScreen === Screen.MoreDetails && (
          <>
            <CustomIcon path={Parameters}></CustomIcon>
            <p className={classes.header}>Parameters Passed</p>
            <button
              className={classes.cross}
              onClick={() => {
                handleScreenChange(Screen.Default)
              }}
            >
              <CustomIcon path={Close}></CustomIcon>
            </button>
          </>
        )}

        {activeScreen === Screen.ViewMore && (
          <>
            <CustomIcon path={Correct}></CustomIcon>
            <p className={classes.header}>Progress</p>
            <button
              className={classes.cross}
              onClick={() => {
                handleScreenChange(Screen.Default)
              }}
            >
              <CustomIcon path={Close}></CustomIcon>
            </button>
          </>
        )}
      </div>
      {deepDiveData.map((item: IPipelineData, index: number) => (
        <Box
          className={
            index % 2 === 0 ? "bg-primaryGrey-100 grid grid-cols-2" : "grid"
          }
          sx={{
            gridTemplateColumns:
              activeScreen == Screen.Default
                ? "1fr 2fr"
                : activeScreen === Screen.MoreDetails
                ? "2fr 1.5fr"
                : "1fr 2fr",
          }}
          key={index}
        >
          <div className="flex flex-row justify-start items-center mx-2 my-2">
            {activeScreen == Screen.Default && (
              <img
                className="mx-0.5 my-0.5"
                src={icons.monitoringDeepDiveImages[index]}
              ></img>
            )}
            <div className={classes.key}>
              {item.name} {activeScreen === Screen.MoreDetails ? ":" : ""}
            </div>
          </div>
          <Box className={classes.value + " font-bold"} sx={{ gap: 6 }}>
            {PIPELINE_NAMES_MAPPER[item.value]
              ? PIPELINE_NAMES_MAPPER[item.value]
              : item.value}
            {item.key === "progress" ? (
              <div className={classes.moreDetailsWrapper}>
                <CustomizedProgressBar percentage={item.percentage || 0} />
                {activeScreen === Screen.Default && (
                  <button
                    className={classes.link}
                    onClick={() => {
                      handleScreenChange(Screen.ViewMore)
                    }}
                  >
                    More Details
                  </button>
                )}
              </div>
            ) : (
              ""
            )}
            {item.key === "parameters_passed" &&
            activeScreen === Screen.Default ? (
              <button
                className={classes.link}
                onClick={() => {
                  handleScreenChange(Screen.MoreDetails)
                }}
              >
                View More
              </button>
            ) : (
              ""
            )}
          </Box>
        </Box>
      ))}
    </div>
  )
}

export default MonitoringDeepDiveTable
